const PERSIAN_DIGITS = '۰۱۲۳۴۵۶۷۸۹'

export const toPersianDigits = (value: string | number): string => {
    return String(value).replace(/[0-9]/g, (digit) => PERSIAN_DIGITS[Number(digit)])
}

// Deterministic on server and client, so it never causes a hydration mismatch
export const formatNumber = (value: number): string => {
    const grouped = Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '٬')

    return toPersianDigits(grouped)
}

// Visitors may type Persian or Arabic digits; validation and storage work on ASCII digits
export const toLatinDigits = (value: string): string => {
    return value
        .replace(/[۰-۹]/g, (digit) => String(digit.charCodeAt(0) - 0x06F0))
        .replace(/[٠-٩]/g, (digit) => String(digit.charCodeAt(0) - 0x0660))
}
